import React, { Component } from 'react';
import FlexText from '../../flexText';
import Anchor from '../../pageElements/anchor';
import Styles from './styles/topSignSmallStyles';

class TopSignSmall extends Component {
  constructor(props) {
    super(props);
    this.state = {
      factoid: [],
      config:[],
      nodeid:[],
    };
  }

  render() {
    if (this.state.config) {
      return (
        <div className="signBoxSmallView">
          <div className="3ButtonNavSmall" style={{...Styles.signStyles, ...this.props.style}}>
            <ul style={Styles.ulStyle}>
              {typeof this.props.links[0] !=="undefined"
                ?<li style={Styles.liStyle}><a tabIndex="0" style={Styles.linkStyle} href={this.props.links[0].url}>{this.props.links[0].title}</a></li>
                :null}
              {typeof this.props.links[1] !=="undefined"
                ?<li style={Styles.liStyle}><a tabIndex="0" style={Styles.linkStyle} href={this.props.links[1].url}>{this.props.links[1].title}</a></li>
                :null}
              {typeof this.props.links[2] !=="undefined"
                ?<li style={Styles.liStyleRight}><a tabIndex="0" style={Styles.linkStyle} href={this.props.links[2].url}>{this.props.links[2].title}</a></li>
                :null}
            </ul>
          </div>
          <Anchor className={this.props.blockStyle.field_link_colors.name + ' signLink'} link={this.props.data[0].field_link_1}>
            <FlexText
              max= "32"
              min= "32"
              pert=".25"
              classes="flexText"
              tag="h2"
              color="#444"
              styles={{
                fontFamily: "Oswald",
                fontSize: "28px",
                display:"block",
                width:"100%",
                textAlign:"center",
                padding:"32px 0px 0px",
                margin:"0px",
                textTransform:"uppercase",
                borderTop: "1px solid #D8D8D8",
              }}>
              {this.props.data[0].field_text_1}
            </FlexText>
            <FlexText
              max= "17"
              min= "17"
              pert=".25"
              classes="flexText"
              tag="div"
              color="#444"
              styles={{
                fontFamily:"Roboto",
                textAlign:"center",
                padding:"16px",
              }}>
              {this.props.data[0].field_longtext_1}
            </FlexText>  
          </Anchor>
        </div>
      );
    } else {
      return (<p>Loading...</p>);
    }
  }
}

export default TopSignSmall;